
export default {
  name: 'CategoryManage',
  data () {
    return {
      categories: [],
      showDialog: false,
      isEdit: false,
      editingId: null,
      iconPreviewError: false,
      form: this.emptyForm()
    }
  },
  methods: {
    emptyForm () {
      return { slug: '', name: '', sort_order: 0, icon: '', is_active: true }
    },
    async fetchCategories () {
      try {
        const res = await this.axios.get('/admin/categories')
        if (res.data.code === 200) this.categories = res.data.data
      } catch (e) {
        console.error('获取品类列表失败:', e)
      }
    },
    openAdd () {
      this.isEdit = false
      this.editingId = null
      this.form = this.emptyForm()
      this.iconPreviewError = false
      this.showDialog = true
    },
    editCategory (cat) {
      this.isEdit = true
      this.editingId = cat.id
      this.form = { slug: cat.slug, name: cat.name, sort_order: cat.sort_order, icon: cat.icon || '', is_active: !!cat.is_active }
      this.iconPreviewError = false
      this.showDialog = true
    },
    closeDialog () {
      this.showDialog = false
    },
    async saveCategory () {
      if (!this.isEdit && !/^[a-z0-9_]+$/.test(this.form.slug || '')) {
        alert('slug 必填，仅小写字母/数字/下划线（创建后不可修改）')
        return
      }
      if (!(this.form.name || '').trim()) {
        alert('品类名称不能为空')
        return
      }
      try {
        if (this.isEdit) {
          // slug 恒不可改：编辑提交 name/icon/sort_order（is_active 走列表启停切换，避免误触）
          const res = await this.axios.put(`/admin/categories/${this.editingId}`, {
            name: this.form.name,
            icon: this.form.icon,
            sort_order: this.form.sort_order
          })
          if (res.data.code !== 200) return alert(res.data.message || '保存失败')
        } else {
          const res = await this.axios.post('/admin/categories', this.form)
          if (res.data.code !== 200) return alert(res.data.message || '创建失败')
        }
        this.showDialog = false
        this.fetchCategories()
      } catch (e) {
        const msg = e.response && e.response.data && e.response.data.message
        alert(msg || '操作失败')
      }
    },
    async toggleActive (cat) {
      const action = cat.is_active ? '停用' : '启用'
      if (!confirm(`确认${action}品类「${cat.name}」？${cat.is_active ? '停用后不再出现在商品编辑选择器（已归属商品不受影响）。' : ''}`)) return
      try {
        const res = await this.axios.put(`/admin/categories/${cat.id}`, {
          name: cat.name,
          icon: cat.icon || '',
          sort_order: cat.sort_order,
          is_active: cat.is_active ? 0 : 1
        })
        if (res.data.code !== 200) return alert(res.data.message || '操作失败')
        this.fetchCategories()
      } catch (e) {
        const msg = e.response && e.response.data && e.response.data.message
        alert(msg || '操作失败')
      }
    },
    async deleteCategory (cat) {
      if (!confirm(`确认删除品类「${cat.name}」？仅零商品引用的品类可物理删除，有商品请改用停用。`)) return
      try {
        const res = await this.axios.delete(`/admin/categories/${cat.id}`)
        if (res.data.code !== 200) return alert(res.data.message || '删除失败')
        this.fetchCategories()
      } catch (e) {
        // 409 = 有商品引用，后端 message 带具体数量
        const msg = e.response && e.response.data && e.response.data.message
        alert(msg || '删除失败')
      }
    }
  },
  created () {
    this.fetchCategories()
  }
}
